export default "__VITE_ASSET__f04ea0a3__"